import { render, staticRenderFns } from "./InReviewTasks.vue?vue&type=template&id=46809c1a"
import script from "./InReviewTasks.vue?vue&type=script&lang=js"
export * from "./InReviewTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports